import Link from "next/link";
import { useParams } from "react-router-dom";

const PAGES: Record<string, { title: string; body: string }> = {
  "about-mova": { title: "About MOVA", body: "MOVA Market is a premier e-commerce marketplace in Ethiopia, connecting buyers and sellers with a wide range of quality products delivered nationwide." },
  careers: { title: "Careers", body: "Join the MOVA team and help build the future of online shopping in Ethiopia. Check back soon for open positions." },
  "press-releases": { title: "Press Releases", body: "Latest news and updates about MOVA Market will be published here." },
  "mova-science": { title: "MOVA Science", body: "Innovations and technology projects powering the MOVA Market platform." },
  "sell-on-mova": { title: "Sell on MOVA", body: "Reach millions of customers across Ethiopia by listing your products on MOVA Market." },
  "mova-accelerator": { title: "MOVA Accelerator", body: "A program supporting growing businesses to scale with MOVA Market." },
  "fulfilment-by-mova": { title: "Fulfilment by MOVA", body: "Let MOVA handle storage, packing and delivery while you focus on selling." },
  "advertise-your-products": { title: "Advertise Your Products", body: "Promote your listings and reach more customers with MOVA advertising." },
  "mova-pay-merchants": { title: "MOVA Pay on Merchants", body: "Accept secure payments from customers with MOVA Pay." },
  "your-account": { title: "Your Account", body: "Manage your profile, orders and settings from your account dashboard." },
  "returns-centre": { title: "Returns Centre", body: "Easily return items and track your refunds in the Returns Centre." },
  "purchase-protection": { title: "100% Purchase Protection", body: "Every order on MOVA is covered by our purchase protection guarantee." },
  "mova-app": { title: "MOVA App Download", body: "Download the MOVA app for a faster, easier shopping experience." },
  help: { title: "Help & Support", body: "Need assistance? Our support team is ready to help you with orders, payments and more. Contact us at +251 93 146 3406 / +251 99 587 1028 (0995871028)." },
  "conditions-of-use": { title: "Conditions of Use & Sale", body: "These conditions govern your use of MOVA Market and purchases made on the platform." },
  "privacy-notice": { title: "Privacy Notice", body: "We respect your privacy and protect your personal data in accordance with applicable laws." },
  "interest-based-ads": { title: "Interest-Based Ads", body: "Learn how MOVA uses interest-based advertising to show you relevant products." },
  abebooks: { title: "AbeBooks", body: "Books, art & collectibles." },
  acx: { title: "ACX", body: "Audiobook Publishing Made Easy." },
  audible: { title: "Audible", body: "Download Audio Books." },
  imdb: { title: "IMDb", body: "Movies, TV & Celebrities." },
  shopbop: { title: "Shopbop", body: "Designer Fashion Brands." },
  "mova-business": { title: "MOVA Business", body: "Everything for your business." },
  "mova-cloud": { title: "MOVA Cloud", body: "Scalable cloud computing services." }
};

export function InfoPage() {
  const { slug } = useParams();
  const page = PAGES[slug ?? ""];

  if (!page) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-16 text-center">
        <h1 className="text-2xl font-bold">Page not found</h1>
        <Link href="/" className="mt-4 inline-block text-amazon-teal hover:underline">Go home</Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <h1 className="text-3xl font-bold">{page.title}</h1>
      <p className="mt-4 text-slate-600 dark:text-slate-300">{page.body}</p>
    </div>
  );
}
